"use strict";

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];

    for (var s in a) {
      Object.prototype.hasOwnProperty.call(a, s) && (e[s] = a[s]);
    }
  }

  return e;
};

function _objectWithoutProperties(e, t) {
  var a = {};

  for (var s in e) {
    0 <= t.indexOf(s) || Object.prototype.hasOwnProperty.call(e, s) && (a[s] = e[s]);
  }

  return a;
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    RadioButton = function RadioButton(e) {
  var t = e.checked,
      a = e.isValid,
      s = e.style,
      r = e.className,
      l = e.text,
      o = _objectWithoutProperties(e, ["checked", "isValid", "style", "className", "text"]),
      c = classnames("blx-radio", r, {
    "blx-disabled": o.disabled,
    "blx-invalid": !a
  });

  return React.createElement("label", {
    style: s,
    className: c
  }, React.createElement("div", {
    className: "blx-radio-label",
    title: l
  }, l), React.createElement("input", _extends({
    type: "radio",
    checked: t
  }, o)), React.createElement("span", {
    className: "blx-radio-check"
  }));
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string
}, RadioButton.defaultProps = {
  checked: !1,
  disabled: !1,
  isValid: !0,
  style: null,
  className: "",
  text: ""
}, module.exports = RadioButton;